import React, { useContext, type FC } from "react";

import { StringParam, useQueryParams, withDefault } from "use-query-params";

import { FETCH_SETTINGS_DETAILS } from "@/queries";
import { useNorthbeamQuery } from "@hooks/http";
import { type FetchSettingsDetails } from "@north-beam/nb-client-side";
import { AccountManagerSectionV2 } from "@pages/settings/account-manager-v2";

import { SideNavContext } from "..";
import { Error } from "../error";
import { useOnboardingStep } from "../onboarding-nav/use-onboarding-number";
import { Steps } from "../steps";

import { Step, type StepChildProps } from "./step";
import { StepContainer } from "./step-container";

export const AccountManagerStep: FC<StepChildProps> = ({
  nextStep,
  previousStep,
  isLast,
}) => {
  const context = React.useContext(SideNavContext);
  const { setSubNavItems } = useContext(SideNavContext);

  if (context.subNavItems?.length > 0) {
    setSubNavItems([]);
  }
  const { data, loading, error } = useNorthbeamQuery<FetchSettingsDetails>(
    FETCH_SETTINGS_DETAILS,
    {},
  );

  const [_, setSearchParams] = useQueryParams({
    subStep: withDefault(StringParam, ""),
    step: withDefault(StringParam, ""),
    provider: withDefault(StringParam, ""),
  });

  const { stepDictionary } = useOnboardingStep();
  return (
    <StepContainer
      isLast={isLast}
      onMoveBackwardButtonClicked={() => {
        setSearchParams({
          step: Steps.INTRODUCTION,
        });
        previousStep && previousStep();
      }}
      knowledgeBaseLink="https://docs.northbeam.io/docs/invite-team"
      knowledgeBaseText="Invite Team"
      title={`${stepDictionary["account-managers"].index}. Invite Team`}
      onMoveForwardButtonClicked={() => {
        setSearchParams({
          step: Steps.BASIC_DETAILS,
        });
        nextStep && nextStep();
      }}
    >
      <Step
        nextStepButtonText={`${stepDictionary["basic-details"].index}. Enter Business Information`}
        nextStep={() => {
          setSearchParams({
            step: Steps.BASIC_DETAILS,
          });
          nextStep && nextStep();
        }}
        loading={loading}
      >
        {data ? (
          <AccountManagerSectionV2 managerUsers={data.me.managerUsers} />
        ) : error ? (
          <Error content="There was an error loading your settings." />
        ) : (
          <></>
        )}
      </Step>
    </StepContainer>
  );
};
